import React from "react";

const TrashIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
    >
      <path
        d="M1 3.99988H13"
        stroke="#EA6B3D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 7.00012V11.5001"
        stroke="#EA6B3D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 7.00012V11.5001"
        stroke="#EA6B3D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.75 3.99988L2.5 12.9999C2.5 13.3977 2.65804 13.7792 2.93934 14.0605C3.22064 14.3418 3.60218 14.4999 4 14.4999H10C10.3978 14.4999 10.7794 14.3418 11.0607 14.0605C11.342 13.7792 11.5 13.3977 11.5 12.9999L12.25 3.99988"
        stroke="#EA6B3D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.75 4V1.75C4.75 1.55109 4.82902 1.36032 4.96967 1.21967C5.11032 1.07902 5.30109 1 5.5 1H8.5C8.69891 1 8.88968 1.07902 9.03033 1.21967C9.17098 1.36032 9.25 1.55109 9.25 1.75V4"
        stroke="#EA6B3D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TrashIcon;
